import Helper from '@ember/component/helper';
import { service } from '@ember/service';
export default class isFuture extends Helper {
  @service clock;

  compute([time]) {
    return this.clock.date < time;
  }
}
